import React, { useState, useRef, useEffect } from 'react';
import Lottie from 'lottie-react';
import WelcomeScreenanimation from '../Assets/animations/welcomscreenrotation.json';
import vikritinext from '../Assets/images/vikritinext.png'
import { useNavigate, useLocation } from 'react-router-dom';
import healthissueicon from '../Assets/images/I have a health Issue.png'
import wellnessicon from '../Assets/images/I want to enhance my wellness.png'

function OnBoardingScreen3() {

    const navigate = useNavigate()
    const location = useLocation()

    return (
        <div className="Onboarding-Screen">
            <div className="flex flex-col items-center w-auto" style={{ width: '100%' }}>

                <div style={{ justifySelf: "flex-start" }} className='flex flex-col items-center'>
                    <div className="Welcome-section-animation">
                        <Lottie animationData={WelcomeScreenanimation} />
                    </div>
                    <p className='text-center Welcome-section-animation-txt mt-5'>What’s Your Health Focus?</p>
                </div>

                <div className="container mt-10" style={{ alignItems: "stretch" }}>

                    <div className='wellnessonboardBox'
                        onClick={() => {
                            navigate('/Wellness', { state: { from: location?.state?.from } })
                        }}
                        style={{
                            background: "linear-gradient(90deg, #FDFDFD 50%, #FFE1C6 50%)",
                            border: "3px solid",
                            borderImage: "linear-gradient(90deg, transparent 40%, #DA6E0B 60%) 1",
                        }}>

                        <p
                            style={{
                                position: "absolute",
                                top: "20px",
                                left: "20px",
                            }}
                        >
                            I want to optimize <br />
                            my well-being
                        </p>

                        <img src={wellnessicon} />
                    </div>

                    <div className='wellnessonboardBox'
                        onClick={() => {
                            navigate('/Diseases', { state: { from: location?.state?.from } })
                        }}

                        style={{
                            background: "linear-gradient(90deg, #FDFDFD 50%, #FFE1C6 50%)",
                            border: "3px solid",
                            borderImage: "linear-gradient(90deg, transparent 40%, #DA6E0B 60%) 1",
                        }}>

                        <p
                            style={{
                                position: "absolute",
                                top: "20px",
                                left: "20px",
                            }}
                        >
                            I need support <br />
                            for a health <br />
                            concern / disease
                        </p>

                        <img src={healthissueicon} />
                    </div>
                </div>

                {/* <div onClick={() => {
                    navigate('/wellness')
                }} style={{ position: 'absolute', justifySelf: "flex-end", bottom: '10px', left: '50%', transform: 'translateX(-50%)' }} className='Vikritinextimgicon'>
                    <img src={vikritinext}></img>
                </div> */}

            </div>
        </div >
    );
}

export default OnBoardingScreen3;
